export default {
  square: {
    name: 'square',
  },
  circle: {
    name: 'circle',
  },
};
